import axios from './../axios';

export const getStatistics = async () => {
  try {
    return await axios.get(`/statistics`);
  } catch (err) {
    return err.response;
  }
};
